module.exports = __webpack_public_path__ + "static/media/ic_close.bde09e39.svg";